import { Routes } from '@angular/router';
import { PageNotFoundPage } from '@splixer/player-ui';

export const appRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/station/station.routes').then((m) => m.stationRoutes),
      },
      {
        path: 'listen',
        redirectTo: 'library'
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'library',
      },
    ],
  },
  { path: '**', component: PageNotFoundPage },
];
